<template>
  <NuxtLink
    :href="`/blog/${article.category.slug}/${article.slug}`"
    class="group flex h-full flex-col rounded-xl border border-gray-200 bg-white p-6 shadow-xs
           hover:border-amber-400 dark:border-stone-700 dark:bg-stone-900 dark:hover:border-amber-500">
    <div class="flex flex-wrap items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
      <span class="font-semibold uppercase tracking-widest text-amber-600 dark:text-amber-400">{{ article.category.name }}</span>
      <span class="text-gray-300 dark:text-gray-600">&bull;</span>
      <time :datetime="String(article.created_at)">{{ formatDate(article.created_at, false) }}</time>
    </div>

    <h3 class="mt-3 font-serif font-semibold text-xl sm:text-2xl leading-snug tracking-tight text-gray-900 dark:text-gray-100 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors">
      {{ article.title }}
    </h3>

    <p class="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400 line-clamp-3 flex-1">
      {{ blogExcerpt(article.description, article.body) }}
    </p>

    <span class="mt-4 inline-flex items-center text-sm font-medium text-amber-600 dark:text-amber-400">
      Read more <span class="ml-1" aria-hidden="true">&rarr;</span>
    </span>
  </NuxtLink>
</template>

<script setup lang="ts">
import { formatDate } from '~/utils/date';
import { blogExcerpt } from '~/utils/blog';

defineProps<{
  article: BlogArticle;
}>();
</script>
